import React from 'react';
import './FaceSwapTechFeatures.css';

const FaceSwapTechFeatures: React.FC = () => {
  const features = [
    {
      title: "Studio Quality",
      description: "Cutting-edge neural models deliver photorealistic swaps with stable identity and natural skin textures.",
      features: [
        "High‑fidelity face detection and alignment",
        "Expression, lighting and color preservation",
        "Artifact‑reduction blending for clean edges"
      ],
      reversed: false
    },
    {
      title: "Swap Single or Multiple Faces in Photos and Videos",
      description: "Swap faces across photos and videos with robust single and multiple face detection, tracking, and replacement.",
      features: [
        "Automatic single/multi‑face detection and ID grouping",
        "Frame‑consistent tracking for stable video results",
        "One‑click replace all or select specific faces to swap"
      ],
      reversed: true
    }
  ];

  return (
    <section className="face-swap-tech-features">
      <div className="tech-features-header">
        <h2 className="features-title">Advanced Technology Features</h2>
      </div>
      
      <div className="features-list">
        {features.map((feature, index) => (
          <div key={index} className={`feature-section ${feature.reversed ? 'reversed' : ''}`}>
            {!feature.reversed ? (
              <>
                <div className="feature-visual">
                  <div className="visual-placeholder">
                  </div>
                </div>
                
                <div className="feature-content">
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                  
                  <div className="feature-list">
                    {feature.features.map((item, itemIndex) => (
                      <div key={itemIndex} className="feature-item">
                        <span className="feature-bullet">•</span>
                        <span className="feature-text">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="feature-content">
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                  
                  <div className="feature-list">
                    {feature.features.map((item, itemIndex) => (
                      <div key={itemIndex} className="feature-item">
                        <span className="feature-bullet">•</span>
                        <span className="feature-text">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="feature-visual">
                  <div className="visual-placeholder">
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FaceSwapTechFeatures;